import React from "react";
import { Box, TextField } from "@mui/material";
import { styled } from "@mui/system";
import MenuItem from "@mui/material/MenuItem";

const SkillSearchContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  backgroundColor: "#0c0513",
  color: "#c770f0",
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  margin: "0 10px",
  "& .MuiInputBase-input": {
    color: "#fff",
  },
  "& .MuiInputLabel-root": {
    color: "#c770f0",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#c770f0",
    },
    "&:hover fieldset": {
      borderColor: "#c770f0",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#c770f0",
    },
  },
}));

const SkillSearch = ({ searchKeyword, filterSkills }) => {
  return (
    <SkillSearchContainer>
      <StyledTextField
        style={{ width: "90%" }}
        variant="outlined"
        label="keyword"
        size="small"
        name="keyword"
        onChange={(e) => {
          searchKeyword(e.target.value);
        }}
        placeholder="Pytho..."
      />
      <StyledTextField
        style={{ width: "90%" }}
        select
        variant="outlined"
        label="Select"
        size="small"
        name="select"
        defaultValue={"all"}
        onChange={(e) => {
          filterSkills(e.target.value);
        }}
      >
        <MenuItem key="mastery" value="mastery">
          🌟 Mastery
        </MenuItem>
        <MenuItem key="pro" value="pro">
          💪 Pro Level
        </MenuItem>
        <MenuItem key="getting" value="getting">
          🚀 Getting There
        </MenuItem>
        <MenuItem key="exploring" value="exploring">
          🔍 Exploring
        </MenuItem>
        <MenuItem key="all" value="all">
          🧠 All Skills
        </MenuItem>
      </StyledTextField>
    </SkillSearchContainer>
  );
};

export default SkillSearch;
